import { post } from "app/popleads/networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { useState } from "react";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useEtiketSil = () => {
    const { refetchEtiketList } = useExtensionContext();
    const [etiketSilLoading, setEtiketSilLoading] = useState(false);

    const etiketSil = async ({ profil, etiket }) => {
        try {
            setEtiketSilLoading(true);
            const response = await post({
                fn: "etiketSil",
                profil,
                etiket,
            });

            if (response?.data?.stat === "ok") {
                toast.success("Campaign deleted successfully");
                refetchEtiketList();
            }
        } catch (error) {
            const errorMessage = apiErrorText(error);
            toast.error(errorMessage);
            setEtiketSilLoading(false);
            return { success: false, error: errorMessage };
        } finally {
            setEtiketSilLoading(false);
        }
    };

    return { etiketSil, etiketSilLoading };
};

export default useEtiketSil;
